export const BlogParagraph = ( prop ) =>{
    return(
        <>
   
        <p className='blog-text'>
           {prop.text}
        </p>
        </>
    )
}

